<template>
  <editor
    v-if="instance"
    v-model="instance"
    :is-new="isNew"
    :disabled="!editing"
    :errors="validationErrors"
    @cancel="cancel"
    @edit="edit"
    @removed="removed"
    @reset-errors="resetErrors"
    @saved="saved"
    @save-error="handleError"
    @load="load"
  />
</template>
<script>
import LoadPageMixin from "vue-template/protected/mixins/LoadPageMixin";
import pluralize from "pluralize";
import lowerFirst from "lodash/lowerFirst";

export default {
  mixins: [LoadPageMixin],

  methods: {
    getService() {
      throw Error("Virtual method");
    },

    getLabel(/*instance*/) {
      throw Error("Virtual method");
    },

    breadcrumbs() {
      const routeName = this.$route.name;

      return [
        {
          icon: "home",
          text: "Home",
          to: "/protected"
        },
        {
          text: () => this.$t("menu." + lowerFirst(pluralize(routeName))),
          to: { name: pluralize(routeName) }
        },
        {
          text:
            this.$route.params.id === "new"
              ? "<New>"
              : this.getLabel(this.instance) || "<New>"
        }
      ];
    },

    edit() {
      const params = { id: this.instance.id };
      const query = { edit: true };
      this.$router.push({ name: this.$route.name, params, query });
    },

    cancel() {
      this.$router.push({ name: pluralize(this.$route.name) });
    },

    removed(/*instance*/) {
      this.$router.push({ name: pluralize(this.$route.name) });
    },

    saved(instance) {
      const params = { id: instance.id };
      this.$router.push({ name: this.$route.name, params });
    }
  }
};
</script>
